import type { TenantStatus } from '../types'

/**
 * Status, with the colour paired to a word rather than carrying the meaning alone —
 * the same rule the product's own StatusBadge follows for WCAG 1.4.1.
 */
const TONE: Record<TenantStatus, string> = {
  TRIAL: 'bg-[var(--color-tint-blue)] text-[var(--color-info)]',
  ACTIVE: 'bg-[var(--color-tint-green)] text-[var(--color-success)]',
  PAST_DUE: 'bg-[var(--color-tint-orange)] text-[var(--color-warning)]',
  SUSPENDED: 'bg-[var(--color-tint-red)] text-[var(--color-danger)]',
  CANCELLED: 'bg-slate-100 text-slate-600',
  ARCHIVED: 'bg-slate-100 text-slate-600',
}

const LABEL: Record<TenantStatus, string> = {
  TRIAL: 'Trial',
  ACTIVE: 'Active',
  PAST_DUE: 'Past due',
  SUSPENDED: 'Suspended',
  CANCELLED: 'Cancelled',
  ARCHIVED: 'Archived',
}

export function TenantStatusBadge({ status }: { status: TenantStatus }) {
  return (
    <span className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium ${TONE[status]}`}>
      {LABEL[status]}
    </span>
  )
}
